export default __webpack_public_path__ + "static/media/check-girl.74d383e2.gif";